import React, { useCallback, useState } from "react";
import { Page, Card, Tabs } from "@shopify/polaris";

import Report from "./components/knotReport/report";
import store from "store-js";

function KnotReport() {
  const currentTab = store.get("solrTab") || 0;
  const [selected, setSelected] = useState(currentTab);

  store.set("solrTab", selected);

  const handleTabChange = useCallback((index) => setSelected(index), []);

  const tabs = [
    {
      id: "knotReport",
      title: "Knot Report",
      content: "Knot Report",
      page: <Report />,
      panelID: "knotReportPanel",
    },
  ];

  return (
    <Page breadcrumbs={[{ url: "/" }]} title={tabs[selected].title} fullWidth>
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          {tabs[selected].page}
        </Tabs>
      </Card>
    </Page>
  );
}

export default KnotReport;
